import { X, ExternalLink } from "lucide-react";
import { fileSrc } from "@/lib/uploads";
import { formatDateTimeAR } from "@/lib/i18n";

/** Fix BN (2026-11-03): herramientas que se controlan en el egreso de un vehículo de la empresa.
 * Checklist OPCIONAL: cada ítem puede quedar sin marcar. Mismas claves que VEHICLE_TOOLS del backend. */
export const VEHICLE_TOOLS = [
  { key: "rueda_auxilio", label: "Rueda de auxilio" },
  { key: "matafuego", label: "Matafuego" },
  { key: "crique", label: "Crique" },
  { key: "balizas", label: "Balizas" },
  { key: "chaleco_reflectivo", label: "Chaleco reflectivo" },
  { key: "llave_cruz", label: "Llave cruz" },
];

export function VehicleToolsCheck({ value = {}, onChange, testIdPrefix = "veh-tools" }) {
  const toggle = (key, v) => {
    const next = { ...value };
    if (next[key] === v) delete next[key]; else next[key] = v;
    onChange(next);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }} data-testid={testIdPrefix}>
      {VEHICLE_TOOLS.map(({ key, label }) => (
        <div key={key} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ flex: 1, fontSize: 13, fontWeight: 700 }}>{label}</span>
          {[{ v: "ok", l: "Tiene", c: "#16a34a" }, { v: "falta", l: "Falta", c: "#BF3437" }].map(({ v, l, c }) => (
            <button key={v} type="button" onClick={() => toggle(key, v)} data-testid={`${testIdPrefix}-${key}-${v}`}
              style={{ padding: "6px 12px", fontSize: 11, fontWeight: 800, borderRadius: 4, cursor: "pointer",
                border: `1.5px solid ${value[key] === v ? c : "var(--invict-bone-3)"}`,
                background: value[key] === v ? c : "#fff", color: value[key] === v ? "#fff" : "#0A0A0A" }}>{l}</button>
          ))}
        </div>
      ))}
      <span style={{ fontSize: 10, color: "var(--invict-text-muted)" }}>Opcional: marcá solo lo que controlaste.</span>
    </div>
  );
}

export function toolsSummary(tools) {
  const marked = VEHICLE_TOOLS.filter((t) => tools && tools[t.key]);
  if (!marked.length) return null;
  return marked.map((t) => `${t.label}: ${tools[t.key] === "ok" ? "tiene" : "FALTA"}`).join(" · ");
}

/** Fix BN: detalle completo de un movimiento (antes solo se veía una miniatura de la foto). */
export function VehicleDetailModal({ vehicle: v, onClose }) {
  if (!v) return null;
  const rows = [
    ["Movimiento", v.direction === "entrada" ? "Entrada" : "Salida"],
    ["Cliente", v.client_name],
    ["Fecha y hora", formatDateTimeAR(v.created_at)],
    ["Registró", v.user_name],
    ["Vehículo de la empresa", v.is_company_vehicle ? "Sí" : null],
    ["Descripción", v.description],
    ["Motivo", v.reason],
    ["Conductor", [v.driver_surname, v.driver_name].filter(Boolean).join(", ") || null],
    ["DNI conductor", v.driver_dni],
    ["Patente", v.plate_source === "ocr" ? "Leída de la foto" : null],
  ].filter(([, val]) => val);
  const tools = v.tools_check || {};
  const marked = VEHICLE_TOOLS.filter((t) => tools[t.key]);
  return (
    <div className="modal-overlay" onClick={onClose} data-testid="veh-detail-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: "85vh", overflowY: "auto" }} data-testid="veh-detail">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
          <h3 style={{ margin: 0, fontFamily: "monospace", letterSpacing: "0.1em" }}>{v.plate}</h3>
          <button onClick={onClose} className="btn-ghost" style={{ padding: 6 }} data-testid="veh-detail-close"><X size={16} /></button>
        </div>
        {v.plate_photo_url && (
          <a href={fileSrc(v.plate_photo_url)} target="_blank" rel="noreferrer" style={{ display: "block", marginBottom: 12, textDecoration: "none" }} data-testid="veh-detail-photo">
            <img src={fileSrc(v.plate_photo_url)} alt="Foto del vehículo" style={{ width: "100%", maxHeight: 360, objectFit: "contain", background: "#0A0A0A", borderRadius: 4 }} />
            <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 11, fontWeight: 700, marginTop: 4, color: "#0A0A0A" }}>
              <ExternalLink size={12} /> Abrir la foto en tamaño completo
            </span>
          </a>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "6px 14px", fontSize: 13 }}>
          {rows.map(([k, val]) => (
            <div key={k} style={{ display: "contents" }}>
              <span style={{ color: "var(--invict-text-muted)", fontWeight: 700 }}>{k}</span>
              <span style={{ color: "#0A0A0A" }}>{val}</span>
            </div>
          ))}
        </div>
        {marked.length > 0 && (
          <div style={{ marginTop: 14 }} data-testid="veh-detail-tools">
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6 }}>Herramientas controladas</div>
            {marked.map((t) => (
              <div key={t.key} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "3px 0" }}>
                <span>{t.label}</span>
                <b style={{ color: tools[t.key] === "ok" ? "#16a34a" : "#BF3437" }}>{tools[t.key] === "ok" ? "Tiene" : "Falta"}</b>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
